"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2596],{

/***/ 26102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ custom_hooks_useLeadCountMutation; }
});

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/models/endpoits/clients/lead counter/lead.counts.endpoints.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var LeadsStatic;

(function (LeadsStatic) {})(LeadsStatic || (LeadsStatic = {}));

var LeadsDynamic = {
  /**
   * @member {string}
   * @method POST
   * @version 2.0
   * @description post leads dynamic counter.
   */
  add: function add(realestate_id) {
    return "/v2/clients/realestates/".concat(realestate_id, "/lead-count");
  }
};
var LeadsCountEndpoints = _objectSpread(_objectSpread({}, LeadsDynamic), LeadsStatic);
// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
;// CONCATENATED MODULE: ./api/clients/leads counter/leads.counter.request.ts


function addLeadCount(values) {
  return (0,base_services_request/* postRequest */.j0)(LeadsCountEndpoints.add(values.params.realestate_id), values.body, true).then(function (_ref) {
    var data = _ref.data;
    return data === null || data === void 0 ? void 0 : data.data;
  });
}
;// CONCATENATED MODULE: ./custom-hooks/useLeadCountMutation.tsx



var useLeadCountMutation = function useLeadCountMutation() {
  var _useMutation = (0,useMutation/* useMutation */.D)({
    mutationFn: addLeadCount
  }),
      ADD_LEAD_COUNT_M = _useMutation.mutate;

  return {
    ADD_LEAD_COUNT_M: ADD_LEAD_COUNT_M
  };
};

/* harmony default export */ var custom_hooks_useLeadCountMutation = (useLeadCountMutation);

/***/ }),

/***/ 21689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var custom_hooks_useSnackBar_hook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71652);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(50657);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48228);
/* harmony import */ var api_messages_request__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27929);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var custom_hooks_data_layer_event_hook__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65198);
/* harmony import */ var _ContactForm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97064);
/* harmony import */ var _message_modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36481);
/* harmony import */ var custom_hooks_useLeadCountMutation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26102);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70917);




function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var postData = /*#__PURE__*/function () {
  var _ref = (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(data) {
    var response;
    return _usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,api_messages_request__WEBPACK_IMPORTED_MODULE_4__/* .postMessageAgent */ .Jk)(data);

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function postData(_x) {
    return _ref.apply(this, arguments);
  };
}();

function ContactAgentDialog(props) {
  var _useLeadCountMutation = (0,custom_hooks_useLeadCountMutation__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(),
      ADD_LEAD_COUNT_M = _useLeadCountMutation.ADD_LEAD_COUNT_M;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();

  var _useDataLayerEvent = (0,custom_hooks_data_layer_event_hook__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(),
      event = _useDataLayerEvent.event;

  var open = props.open,
      onClose = props.onClose,
      defaultMessage = props.defaultMessage;

  var _useSnackBar = (0,custom_hooks_useSnackBar_hook__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(),
      showMessage = _useSnackBar.showMessage;

  var translation = (0,next_intl__WEBPACK_IMPORTED_MODULE_11__.useTranslations)("alerts.contactAgent");
  var translationAlert = (0,next_intl__WEBPACK_IMPORTED_MODULE_11__.useTranslations)("alerts.contact");

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      openSuccessDialog = _useState[0],
      setSuccessDialog = _useState[1];

  var _useMutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_12__/* .useMutation */ .D)(postData, {
    onSuccess: function onSuccess() {
      handleModalDialog();
      setTimeout(function () {
        handleModalDialog();
        onClose();
      }, 500);
    },
    onError: function onError() {
      return showMessage(translation("titleError"), {
        variant: "error"
      });
    }
  }),
      mutateAsync = _useMutation.mutateAsync,
      isLoading = _useMutation.isLoading;

  var handleModalDialog = function handleModalDialog() {
    setSuccessDialog(!openSuccessDialog);
  };

  var onSubmit = function onSubmit(values) {
    props.onCallBackSubmit && props.onCallBackSubmit();
    var data = {
      realstate_id: props.realestateId,
      agent_id: props.entity_info.id,
      permalink: props.realestateId ? window.location.href : "",
      client_name: values.full_name,
      client_email: values.email,
      client_phone: values.phone,
      client_message: values.message,
      "g-recaptcha-response": values.captcha,
      subscribe: values.subscribe
    };

    if (props.isAgency) {
      delete data.agent_id;
      data.agency_id = props.entity_info.id;
    }

    if (props.extraDataLayer) {
      var _router$query;

      event({
        event_name: (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.areferer ? "correo_agencia_propiedad" : "correo_agente_propiedad",
        body: props.extraDataLayer
      });
    }

    mutateAsync(data).then(function () {
      props.onCallBackSubmitEnd && props.onCallBackSubmitEnd();
    });
  };

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(StyledDialog, {
    open: open
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_ContactForm__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    onSubmit: onSubmit,
    onClose: onClose,
    classNameModalButton: props.classNameModalButton,
    isLoading: isLoading,
    defaultMessage: defaultMessage,
    className: props.customClass
  })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(StyledModalMessage, {
    title: translationAlert("titleSuccess"),
    body: translationAlert("bodySuccess"),
    open: openSuccessDialog,
    handleClose: handleModalDialog
  }));
}

var StyledDialog = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z,  true ? {
  target: "et1gf151"
} : 0)( true ? {
  name: "2dq3js",
  styles: "& .MuiDialog-paper{background-color:var(#efeff1);border-radius:20px;}"
} : 0);

var StyledModalMessage = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_message_modal__WEBPACK_IMPORTED_MODULE_6__/* .ModalMessage */ .P,  true ? {
  target: "et1gf150"
} : 0)( true ? {
  name: "983j4x",
  styles: "& .MuiBox-root{width:90%;border-radius:20px;max-width:400px;}"
} : 0);

/* harmony default export */ __webpack_exports__["Z"] = (ContactAgentDialog);

/***/ }),

/***/ 20518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_icons_material_ArrowBackIosNewRounded__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76083);
/* harmony import */ var _mui_icons_material_ArrowForwardIosRounded__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47111);
/* harmony import */ var custom_hooks_use_width_hook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44231);
/* harmony import */ var _slick_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84256);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11496);


var _templateObject;










function CustomCarrusel(props) {
  var _props$colorArrow, _props$colorArrow2, _props$children, _props$numberOfPlaceh;

  var width = (0,custom_hooks_use_width_hook__WEBPACK_IMPORTED_MODULE_2__/* .useWidth */ .z)();
  var rows = {
    xs: 1,
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4
  };
  var arrowsLeft =
  /*#__PURE__*/

  /*#__PURE__*/
  (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("color:", (_props$colorArrow = props.colorArrow) !== null && _props$colorArrow !== void 0 ? _props$colorArrow : "var(--color-brand-blue-main)", "!important;font-size:clamp(1.5rem, 2.5vw, 2.6rem);padding:2px;position:absolute;z-index:500;left:", width === "xs" || width === "sm" ? "-25px" : "-50px", "!important;top:50%;transform:translateY(-50%);@media (max-width: 600px){left:-15px!important;font-size:1.8rem;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0);
  var arrowsRight =
  /*#__PURE__*/

  /*#__PURE__*/
  (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("color:", (_props$colorArrow2 = props.colorArrow) !== null && _props$colorArrow2 !== void 0 ? _props$colorArrow2 : "var(--color-brand-blue-main)", "!important;font-size:clamp(1.5rem, 2.5vw, 2.6rem);padding:2px;position:absolute;z-index:500;right:", width === "xs" || width === "sm" ? "-25px" : "-50px", "!important;top:50%;transform:translateY(-50%);@media (max-width: 600px){right:-15px!important;font-size:1.8rem;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0);
  var settings = {
    dots: false,
    infinite: ((_props$children = props.children) === null || _props$children === void 0 ? void 0 : _props$children.length) > rows[width],
    speed: 500,
    slidesToShow: rows[width],
    slidesToScroll: 1,
    centerMode: false,
    nextArrow: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_mui_icons_material_ArrowForwardIosRounded__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      css: arrowsRight
    }),
    prevArrow: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_mui_icons_material_ArrowBackIosNewRounded__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      css: arrowsLeft
    }),
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false
      }
    }, {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false
      }
    }]
  };
  var fakeElements = Array.from({
    length: (_props$numberOfPlaceh = props.numberOfPlaceholderItems) !== null && _props$numberOfPlaceh !== void 0 ? _props$numberOfPlaceh : 5
  }, function (v, i) {
    return i;
  });
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(CarruselContainer, {
    container: true,
    justifyContent: "center"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
    item: true,
    xs: 11,
    sm: 11,
    md: 11,
    lg: 10,
    xl: 10,
    my: "auto"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_slick_slider__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, settings, !(props !== null && props !== void 0 && props.children) && props.enablePlaceholder && fakeElements.map(function (e, i) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(props.placeholderItem, {
      key: i
    });
  }), (props === null || props === void 0 ? void 0 : props.children) && props.children)));
}

/* harmony default export */ __webpack_exports__["Z"] = (CustomCarrusel);
var CarruselContainer = (0,_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_templateObject || (_templateObject = (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n  position: relative;\n  margin: 5px 0px;\n  \n  & .slick-slider {\n  \n    position: relative;\n  }\n  \n  & .slick-arrow {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 10;\n    \n    &:before {\n      display: none;\n    }\n  }\n  \n  & .slick-prev {\n    left: -40px;\n    \n    @media (max-width: 900px) {\n      left: -25px;\n    }\n    \n    @media (max-width: 600px) {\n      left: -10px;\n    }\n  }\n  \n  & .slick-next {\n    right: -40px;\n    \n    @media (max-width: 900px) {\n      right: -25px;\n    }\n    \n    @media (max-width: 600px) {\n      right: -10px;\n    }\n  }\n  \n  & .slick-list {\n    overflow: hidden;\n  }\n  \n  & .slick-track {\n    display: flex;\n    align-items: stretch;\n  }\n  \n  & .slick-slide {\n    > div {\n      height: 100%;\n    }\n  }\n"])));

/***/ }),

/***/ 84256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);

 // Import css files





function SlickSlider(props) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_slick__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, props);
}

/* harmony default export */ __webpack_exports__["Z"] = (SlickSlider);

/***/ }),

/***/ 99225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ws_contact_group; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/WhatsApp.js
var WhatsApp = __webpack_require__(84007);
// EXTERNAL MODULE: ./shared/components/mask-components/index.tsx + 1 modules
var mask_components = __webpack_require__(6107);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/ws-button-whatsapp/index.tsx





var sharestylebtn = "\n  width: 100%;\n  height: 45px;\n  max-width: 300px;\n  border-radius: 50px;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  display: flex;\n  padding: 0 1.5rem;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-weight: 500;\n  font-size: 0.9rem;\n  letter-spacing: 0.3px;\n  transition: all 0.3s ease;\n  font-family: var(--font-family);\n  column-gap: 8px;\n    margin: auto;\n";

var ButtonWhatsapp = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "eyrr2bz0"
} : 0)(sharestylebtn, " background-color:var(--color-brand-green-main);" + ( true ? "" : 0));

var WsButtonWhatsapp = function WsButtonWhatsapp(_ref) {
  var onClick = _ref.onClick,
      phone = _ref.phone,
      style = _ref.style;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(ButtonWhatsapp, {
    onClick: onClick,
    style: style
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(WhatsApp/* default */.Z, null), "WhatsApp", (0,emotion_react_browser_esm/* jsx */.tZ)(mask_components/* PhoneMask */.Qv, {
    value: phone,
    displayType: "text"
  }));
};

/* harmony default export */ var ws_button_whatsapp = (WsButtonWhatsapp);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/LocalPhone.js
var LocalPhone = __webpack_require__(60768);
;// CONCATENATED MODULE: ./shared/components/ws-button-phone/index.tsx





var ws_button_phone_sharestylebtn = "\n  width: 100%;\n  height: 45px;\n  max-width: 300px;\n  border-radius: 50px;\n  border: none;\n  outline: none;\n  padding: 0 1.5rem;\n  \n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-weight: 500;\n  font-size: 0.9rem;\n  letter-spacing: 0.3px;\n  transition: all 0.3s ease;\n  font-family: var(--font-family);\n  column-gap: 8px;\n  margin: auto;\n \n";

var ButtonPhone = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "efpme800"
} : 0)(ws_button_phone_sharestylebtn, " background-color:black;" + ( true ? "" : 0));

var WsButtonPhone = function WsButtonPhone(_ref) {
  var phone = _ref.phone,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "LLAMAR" : _ref$label,
      style = _ref.style,
      _onClick = _ref.onClick;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(ButtonPhone, {
    style: style,
    onClick: function onClick() {
      return _onClick === null || _onClick === void 0 ? void 0 : _onClick(phone);
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(LocalPhone/* default */.Z, {
    sx: {
      color: "white"
    }
  }), label, (0,emotion_react_browser_esm/* jsx */.tZ)(mask_components/* PhoneMask */.Qv, {
    value: phone,
    displayType: "text"
  }));
};

/* harmony default export */ var ws_button_phone = (WsButtonPhone);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Send.js
var Send = __webpack_require__(26307);
;// CONCATENATED MODULE: ./shared/components/ws-button-mail/index.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var ws_button_mail_sharestylebtn = "\n  width: 100%;\n  height: 45px;\n  max-width: 300px;\n  border-radius: 50px;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  padding: 0 1.5rem;\n  align-items: center;\n  color: white;\n  font-weight: 500;\n  font-size: 0.9rem;\n  letter-spacing: 0.3px;\n  transition: all 0.3s ease;\n  font-family: var(--font-family);\n  column-gap: 18px;\n    margin: auto;\n";

var ButtonMail = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e2mdlm31"
} : 0)(ws_button_mail_sharestylebtn, " flex-direction:row;height:52px;background-color:var(--color-brand-blue-main);" + ( true ? "" : 0));

var TextInfo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e2mdlm30"
} : 0)( true ? {
  name: "u1dk5c",
  styles: "font-size:12px;font-weight:500;color:white"
} : 0);

var WsButtonMail = function WsButtonMail(_ref) {
  var onClick = _ref.onClick,
      email = _ref.email,
      label = _ref.label,
      style = _ref.style;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(ButtonMail, {
    onClick: onClick,
    style: style
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)(Send/* default */.Z, null)), (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    style: {
      display: "flex",
      flexDirection: "column"
    }
  }, label), (0,emotion_react_browser_esm/* jsx */.tZ)(TextInfo, null, email)));
};

/* harmony default export */ var ws_button_mail = (WsButtonMail);
;// CONCATENATED MODULE: ./shared/components/ws-contact-group/index.tsx


function ws_contact_group_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var WsContactGroup = function WsContactGroup(props) {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("property");

  var handleClickWhatsapp = function handleClickWhatsapp(msg) {
    props.wsClick();
    if (props.blockWhatsapp) return;
    window.open("https://wa.me/".concat(props.whatsapp, "?text=").concat(msg), "_blank");
  };

  var handleClickPhone = function handleClickPhone() {
    props.phoneClick();
    if (props.blockPhone) return;
    window.open("tel:".concat(props.phone), "_blank");
  };

  var handleClickEmail = function handleClickEmail() {
    props.emailClick();
    if (props.blockEmail) return;
    window.open("mailto:".concat(props.email), "_blank");
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    spacing: 1,
    alignItems: "center",
    justifyContent: "center"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    mb: 1,
    textAlign: "center"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(DividerContact, null), (0,emotion_react_browser_esm/* jsx */.tZ)(MessageContact, null, translation("contact")), (0,emotion_react_browser_esm/* jsx */.tZ)(DividerContact, null)), props.whatsapp && (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(ws_button_whatsapp, {
    onClick: handleClickWhatsapp,
    phone: props.whatsapp
  })), props.phone && (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(ws_button_phone, {
    phone: props.phone,
    onClick: handleClickPhone
  })), props.email && (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(ws_button_mail, {
    onClick: handleClickEmail,
    email: props.email,
    label: translation("sendMessage")
  })));
};

/* harmony default export */ var ws_contact_group = (WsContactGroup);

var MessageContact = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1yt39nz1"
} : 0)( true ? {
  name: "1ao3cwl",
  styles: "font-size:1rem;font-weight:600;color:black;margin:10px auto;color:var(--color-brand-blue-main)"
} : 0);

var DividerContact = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Divider/* default */.Z,  true ? {
  target: "e1yt39nz0"
} : 0)( true ? {
  name: "1xo2hv5",
  styles: "height:1px;display:block;width:100%;background-color:#e0e0e0"
} : 0);

/***/ })

}]);